import { switchDomain, switchOrigin } from '@/BuildUtils'
import { MicroAppId } from '@core/application/ApplicationConstants'
import { useElectron } from './core/compositions/Electron'

const {
  VITE_ENTRY_URL_MAPP_FILE,
  VITE_ENTRY_URL_MAPP_KINGSOFT_DOCUMENT,
  VITE_ENTRY_URL_MAPP_STICKY_NOTES,
  VITE_BACKEND_API_BASE_URL,
  VITE_BACKEND_PUSH_URL,
  VITE_BACKEND_FILE_DOWNLOAD_URL,
  VITE_SMF_SERVER_API_BASE_URL,
  VITE_SMF_SERVER_FILE_BASE_URL,
  VITE_URT_CLOUD_DATA_URL,
  VITE_LOGIN_PAGE_URL,
  VITE_BACKEND_API_BASE_ORIGIN,
  VITE_BACKEND_ALB_BASE_ORIGIN,
  VITE_ENTRY_URL_MAPP_QQ_DOCUMENT,
  VITE_ENTRY_URL_MAPP_TRANSFER_DOCK,
  VITE_ENTRY_URL_MAPP_CLOUD_DOCUMENT,
} = import.meta.env

const mappEntryUrlMap = new Map<MicroAppId, string>([
  [MicroAppId.FILE_MANAGER, VITE_ENTRY_URL_MAPP_FILE],
  [MicroAppId.KINGSOFT_DOCUMENT, VITE_ENTRY_URL_MAPP_KINGSOFT_DOCUMENT],
  [MicroAppId.STICKY_NOTES, VITE_ENTRY_URL_MAPP_STICKY_NOTES],
  [MicroAppId.QQ_DOCUMENT, VITE_ENTRY_URL_MAPP_QQ_DOCUMENT],
  [MicroAppId.TRANSFER_DOCK, VITE_ENTRY_URL_MAPP_TRANSFER_DOCK],
  [MicroAppId.CLOUD_DOCUMENT, VITE_ENTRY_URL_MAPP_CLOUD_DOCUMENT],
])

export const getBackendApiGatewayBaseUrl = () => switchDomain(VITE_BACKEND_API_BASE_URL)

export const getBackendPushUrl = () => switchDomain(VITE_BACKEND_PUSH_URL)

export const getBackendFileDownloadBaseUrl = () => switchDomain(VITE_BACKEND_FILE_DOWNLOAD_URL)

export const getSmfServerApiBaseUrl = () => switchDomain(VITE_SMF_SERVER_API_BASE_URL)

export const getSmfServerFileBaseUrl = () => switchDomain(VITE_SMF_SERVER_FILE_BASE_URL)

export const getUrtCloudDataUrl = () => switchDomain(VITE_URT_CLOUD_DATA_URL)

export const getMappEntryUrlByAppId = (appId: MicroAppId) => switchDomain(mappEntryUrlMap.get(appId) || '')

export const getLoginPageUrl = () =>
  switchDomain(`${VITE_LOGIN_PAGE_URL}${useElectron() === undefined ? '' : '/workbench/loginmac.html'}`)

export const getApiBaseOrigin = () => switchOrigin(VITE_BACKEND_API_BASE_ORIGIN)

export const getAlbBaseOrigin = () => switchOrigin(VITE_BACKEND_ALB_BASE_ORIGIN)

export const DataSyncerConfig = {
  TOPIC_KEY: 'owork_sync_data',
  APP_PACKAGE_NAME: 'com.oplus.owork',
  HOST: getUrtCloudDataUrl(),
  APP_VERSION: '1',
  APP_KEY: 'null',
  USER_NAME: 'client',
  PASSWORD: '',
  CLIENT_ID: 'OplusOfficeWebClient',
  GROUP_ID: undefined,
  TIMEOUT_IN_MSEC: 5000,
  DEVICE_TOPIC: (sessionId: string): string => `/server/${sessionId}/OplusOfficeWebClient`,
}
